:host {
  --button-font-weight: 500;
  --button-primary-color: rgba(253, 80, 0, 1);

  /* 按钮尺寸 默认md */
  --button-sm-height: 24px;
  --button-md-height: 36px;
  --button-lg-height: 48px;
  --button-xl-height: 56px;

  --button-sm-radius: 12px;
  --button-md-radius: 18px;
  --button-lg-radius: 24px;
  --button-xl-radius: 28px;

  --button-sm-hspacing: 12px;
  --button-md-hspacing: 24px;
  --button-lg-hspacing: 32px;
  --button-xl-hspacing: 32px;

  --button-sm-font-size: 14px;
  --button-md-font-size: 16px;
  --button-lg-font-size: 18px;
  --button-xl-font-size: 22px;
  /* 按钮尺寸 默认md */

  /* 按钮颜色 默认md */
  --button-primary-bg: rgba(253, 80, 0, 1);
  --button-primary-font-color: #ffffff;
  --button-primary-border-color: rgba(253, 80, 0, 1);
  --button-primary-active-color: #fd2f00;

  --button-danger-bg: #F72626;
  --button-danger-font-color: #ffffff;
  --button-danger-border-color: #F72626;
  --button-primary-active-color: #fd2f00;

  --button-warning-bg: #FB990F;
  --button-warning-font-color: #ffffff;
  --button-warning-border-color: #FB990F;

  --button-success-bg: #07C160;
  --button-success-font-color: #ffffff;
  --button-success-border-color: #07C160;
  /* 按钮颜色 默认md */

  position: relative;
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  border-radius: var(--button-md-radius);
  height: var(--button-md-height);
  line-height: 1;
  transition: opacity .3s;
}

:host(:hover:not(:active,[loading])) {
  opacity: 0.9;
}
:host .button-inner {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  line-height: 1;
  gap: 4px;
}

:host(.button-shape-square) {
  --button-sm-radius: 4px;
  --button-md-radius: 4px;
  --button-lg-radius: 4px;
  --button-xl-radius: 4px;
}


:host .button-native {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: unset;
  -webkit-tap-highlight-color: transparent;
  border: none;
  outline: none;
  font-weight: var(--button-font-weight);
  background: transparent;

  padding-left: var(--button-md-hspacing);
  padding-right: var(--button-md-hspacing);
  font-size: var(--button-md-font-size);
  border-radius: var(--button-md-radius);
}

:host .button-native::before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: #000;
  border: inherit;
  border-color: #000;
  border-radius: inherit;
  transform: translate(-50%, -50%);
  opacity: 0;
  content: "";
  transition: opacity .3s;
}
:host .button-native .jackery-button-icon {
  width: calc(var(--button-md-font-size) + 2px);
}

:host(:not([color])) {
  border: 1px solid var(--button-primary-color);
  color: var(--button-primary-color);
}
:host(:not([color])) .button-native {
  color: var(--button-primary-color);
}
:host(:active) .button-native::before {
  opacity: 0.06;
}

/* 按钮尺寸 */
:host([size="sm"]) .button-native {
  padding-left: var(--button-sm-hspacing);
  padding-right: var(--button-sm-hspacing);
  font-size: var(--button-sm-font-size);
  border-radius: var(--button-sm-radius);
}
:host([size="sm"]) .button-native .jackery-button-icon {
  width: calc(var(--button-sm-font-size) + 2px);
}

:host([size="sm"]) {
  border-radius: var(--button-sm-radius);
  height: var(--button-sm-height);
}

:host([size="lg"]) .button-native {
  padding-left: var(--button-lg-hspacing);
  padding-right: var(--button-lg-hspacing);
  font-size: var(--button-lg-font-size);
  border-radius: var(--button-lg-radius);
}

:host([size="lg"]) {
  border-radius: var(--button-lg-radius);
  height: var(--button-lg-height);
}
:host([size="lg"]) .button-native .jackery-button-icon {
  width: calc(var(--button-lg-font-size) + 2px);
}

:host([size="xl"]) .button-native {
  padding-left: var(--button-xl-hspacing);
  padding-right: var(--button-xl-hspacing);
  font-size: var(--button-xl-font-size);
  border-radius: var(--button-xl-radius);
}

:host([size="xl"]) {
  border-radius: var(--button-xl-radius);
  height: var(--button-xl-height);
}
:host([size="xl"]) .button-native .jackery-button-icon {
  width: calc(var(--button-xl-font-size) + 2px);
}
/* 按钮尺寸 */

/* 按钮颜色 */
:host([color="primary"]) .button-native {
  background: var(--button-primary-bg);
  border-color: var(--button-primary-border-color);
  color: var(--button-primary-font-color);
}

:host([color="danger"]) .button-native {
  background: var(--button-danger-bg);
  border-color: var(--button-danger-border-color);
  color: var(--button-danger-font-color);
}


:host([color="warning"]) .button-native {
  background: var(--button-warning-bg);
  border-color: var(--button-warning-border-color);
  color: var(--button-warning-font-color);
}


:host([color="success"]) .button-native {
  background: var(--button-success-bg);
  border-color: var(--button-success-border-color);
  color: var(--button-success-font-color);
}
/* 按钮颜色 */

/* 按钮全宽 */
:host(.button-full) {
  display: block;
}
/* 按钮全宽 */

/* 按钮禁用、加载中 */
:host([disabled]), :host([loading]) {
  opacity: 0.6;
  cursor: not-allowed;
}
:host([disabled]) .button-native, :host([loading]) .button-native {
  pointer-events: none;
}
/* 按钮禁用、加载中 */